function SoftwareUpdateModalController(DescriptorService) {
  const ctrl = this;
  const getPackageHeader = DescriptorService.getPackageHeader;

  ctrl.$onInit = () => {
    ctrl.packages = ctrl.resolve.packages;
    ctrl.train = ctrl.resolve.train;
    ctrl.carNumber = ctrl.resolve.carNumber;
    ctrl.topologyId = ctrl.resolve.topologyId;
    ctrl.descriptors = ctrl.resolve.descriptors;
    ctrl.sanctionedPackages = [];
    ctrl.filterValidPackages();
    if (ctrl.packagesCount > 1) {
      ctrl.multipleAvailable = true;
    } else {
      if (ctrl.filteredPackages.length > 0) {
        ctrl.multipleAvailable = false;
        ctrl.selectPackage(ctrl.filteredPackages[0]);
      }
      if (ctrl.sanctionedPackages.length > 0) {
        ctrl.multipleAvailable = false;
        ctrl.selectPackage(ctrl.sanctionedPackages[0]);
      }
    }
    ctrl.hasManualUploadToTrain = __env.profile !== 'LU';
  };

  ctrl.filterValidPackages = () => {
    ctrl.filteredPackages = ctrl.packages.filter(obj => {
      return obj.descriptor === 'Engineering' || obj.descriptor === 'Valid';
    });
    let sanctioned = ctrl.packages.find(pkg => pkg.descriptor === 'Sanctioned');
    if (sanctioned) {
      ctrl.sanctionedPackages.push(sanctioned);
    }
    ctrl.packagesCount = ctrl.filteredPackages.length + ctrl.sanctionedPackages.length;
  };

  ctrl.choosePackage = pkg => {
    ctrl.updateObject = {
      consist: ctrl.train.status.trainId,
      carNumber: ctrl.carNumber,
      topologyId: ctrl.topologyId,
      packageid: pkg.id,
      fileName: pkg.fileName,
      moduleType: ctrl.packageHeader.module_family_name,
    };
  };

  ctrl.selectPackage = pkg => {
    ctrl.selectedPackage = pkg;
    ctrl.packageHeader = getPackageHeader(pkg);
    ctrl.choosePackage(pkg);
  };

  ctrl.confirmUpdatePackage = () => {
    ctrl.close({ $value: ctrl.updateObject });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('modalDirectives')
  .controller('SoftwareUpdateModalController', SoftwareUpdateModalController);
